import { EMPTY_OBJECT } from '../../../constants/common'
import { EMAILS_SECTION_SUB_VALUES } from '../../../constants/route'
import { EmailTableCellName } from '../Email.enums'
import { EmailTableRowActivities } from '../EmailTableRowActivities'
import { EmailTableRowDateCreated } from '../EmailTableRowDateCreated'
import { EmailTableRowDateUpdated } from '../EmailTableRowDateUpdated'
import { EmailTableRowMessage } from '../EmailTableRowMessage'
import { EmailTableRowParticipants } from '../EmailTableRowParticipants'
import { EmailTableRowServiceRequest } from '../EmailTableRowServiceRequest'
import { EmailTableRowUser } from '../EmailTableRowUser'

import { EmailTableRowUserMultiValuedListCell } from './EmailTableRowUserMultiValuedListCell'

import * as styles from './EmailTableRow.module.css'

export function checkIsRowFocused(item, focusedRow) {
  return item.uuid === focusedRow
}

export function isImportantButtonDisabled(
  sub,
  { permissions: { can_edit_starred: canEditStarred } }
) {
  return (
    !canEditStarred ||
    sub === EMAILS_SECTION_SUB_VALUES.archive ||
    sub === EMAILS_SECTION_SUB_VALUES.trash
  )
}

export function getCellClassName(name) {
  switch (name) {
    case EmailTableCellName.LinkedRequests:
      return styles.EmailTableRowServiceRequestCell
    default:
      return styles.EmailTableRowCell
  }
}

export function renderCell({
  attachedFilesProps,
  item,
  name,
  scrollRef,
  singleEmailAccount,
  ...restProps
}) {
  const {
    archive_copy_entities: {
      contractors,
      external_contacts: externalContacts,
      inhabitants,
      staff_members: staffMembers,
    } = EMPTY_OBJECT,
    unread,
  } = item

  switch (name) {
    case EmailTableCellName.Participants:
      return (
        <EmailTableRowParticipants
          {...restProps}
          item={item}
          scrollRef={scrollRef}
        />
      )
    case EmailTableCellName.Subject:
      return (
        <EmailTableRowMessage
          {...restProps}
          attachedFilesProps={attachedFilesProps}
          item={item}
          scrollRef={scrollRef}
          singleEmailAccount={singleEmailAccount}
        />
      )
    case EmailTableCellName.LinkedRequests:
      return (
        <EmailTableRowServiceRequest
          {...restProps}
          item={item}
          scrollRef={scrollRef}
        />
      )
    case EmailTableCellName.LastMessageCreated:
    case EmailTableCellName.Created:
      return <EmailTableRowDateCreated {...restProps} item={item} />
    case EmailTableCellName.Updated:
      return <EmailTableRowDateUpdated {...restProps} item={item} />
    case EmailTableCellName.UpdatedBy:
      return <EmailTableRowUser {...restProps} item={item} />
    case EmailTableCellName.StaffMembers:
      return (
        <EmailTableRowUserMultiValuedListCell
          {...restProps}
          items={staffMembers}
          scrollRef={scrollRef}
          unread={unread}
        />
      )
    case EmailTableCellName.Inhabitants:
      return (
        <EmailTableRowUserMultiValuedListCell
          {...restProps}
          items={inhabitants}
          scrollRef={scrollRef}
          unread={unread}
        />
      )
    case EmailTableCellName.Contractors:
      return (
        <EmailTableRowUserMultiValuedListCell
          {...restProps}
          items={contractors}
          scrollRef={scrollRef}
          unread={unread}
        />
      )
    case EmailTableCellName.ExternalContacts:
      return (
        <EmailTableRowUserMultiValuedListCell
          {...restProps}
          items={externalContacts}
          scrollRef={scrollRef}
          unread={unread}
        />
      )
    case EmailTableCellName.Activities:
      return (
        <EmailTableRowActivities
          {...restProps}
          item={item}
          scrollRef={scrollRef}
        />
      )
  }
}
